import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9e26dec&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=c9e26dec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e26dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e26dec')) {
      api.createRecord('c9e26dec', component.options)
    } else {
      api.reload('c9e26dec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c9e26dec&scoped=true", function () {
      api.rerender('c9e26dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configs/index.vue"
export default component.exports